export default __webpack_public_path__ + "static/media/ClassifyPreview.3d747a26.mp4";